export const appVersion = "1.3.6"; // for android apk
export const appIosVersion = "1.3.6"; // for ios ipa
